import { defaultImgMetadata, ImageMetadata } from 'modules/creativeLibrary';
import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import noop from 'utils/noop';

type ContentMetadataState = {
  imageMetadata: ImageMetadata;
  setImageMetadata: Dispatch<SetStateAction<ImageMetadata>>;
};

const defaultState: ContentMetadataState = {
  imageMetadata: defaultImgMetadata,
  setImageMetadata: noop,
};

const ContentMetadataContext = createContext(defaultState);

export const ContentMetadataProvider: FC<PropsWithChildren<NonNullable<unknown>>> = ({
  children,
}) => {
  const [imageMetadata, setImageMetadata] = useState<ImageMetadata>(defaultImgMetadata);

  return (
    <ContentMetadataContext.Provider value={{ imageMetadata, setImageMetadata }}>
      {children}
    </ContentMetadataContext.Provider>
  );
};

export const useContentMetadata = () => useContext(ContentMetadataContext);
